import { defineRouting } from 'next-intl/routing'

export const LOCALE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

export const routing = defineRouting({
  locales: ['en', 'ja', 'es', 'ar', 'ko'],
  defaultLocale: 'en',
  localePrefix: 'as-needed',
  localeCookie: {
    name: 'NEXT_LOCALE',
    maxAge: LOCALE_COOKIE_MAX_AGE_SECONDS,
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production',
  },
})

export type AppLocale = (typeof routing.locales)[number]
